// config/menuMapping.js

// 🔹 Main Dashboard Pages
import Dashboard from "../pages/Dashboard/s-item-0-Dashboard";
import WebDashboard from "../pages/Dashboard/s-item-1-Dashboard-Web";
import NetworkDashboard from "../pages/Dashboard/s-item-2-Dashboard-Network";
import CloudDashboard from "../pages/Dashboard/s-item-3-Dashboard-Cloud";
// import SaveConnect from "../pages/Dashboard/s-item-4-Save-Connect";
// import Analytics from "../pages/Dashboard/s-item-5-Analytics";
import MalwareScanner from "../pages/Dashboard/s-item-6-Malware-Scanner";
import DarkwebScanner from "../pages/Dashboard/s-item-7-Darkweb-scan";
// import Compliance from "../pages/Dashboard/s-item-8-Compliance";
import Reports from "../pages/Dashboard/s-item-9-Reports";
import WordPressSites from "../pages/Dashboard/s-item-4-WordPress-Sites";

// 🔹 Cloud Dashboard Images
import AzureIcon from "../assets/img/save-connect/2-azure.png";
import AWSIcon from "../assets/img/save-connect/3-aws.png";
import GCloudIcon from "../assets/img/save-connect/1-google-cloud.png";

// 🔹 Cloud Sub-Pages
import AwsDashboard from "../pages/Dashboard/s-item-3-1-aws";
import AzureDashboard from "../pages/Dashboard/s-item-3-2-azure";
import GcpDashboard from "../pages/Dashboard/s-item-3-3-gcp";
import OciDashboard from "../pages/Dashboard/s-item-3-4-oci";

// 🔹 Cloud Tabs
import AwsConfigView from "../layouts/aws/ViewConfig";
import AwsEc2View from "../layouts/aws/ViewEc2";
import AwsS3View from "../layouts/aws/ViewS3";

import AzureConfigView from "../layouts/azure/ViewConfig";
import AzureVmsView from "../layouts/azure/ViewVms";
import AzureBlobView from "../layouts/azure/ViewBlob";

import {
  GcpMisconfigurations,
  GcpNetworkVulnerabilities,
  GcpWebVulnerabilities,
  OciMisconfigurations,
  OciNetworkVulnerabilities,
  OciWebVulnerabilities,
} from "../pages/Dashboard/cloud/CloudTechnicalRoute";

// import GcpConfigView from "../layouts/gcp/ViewConfig";
// import GcpGceView from "../layouts/gcp/ViewGce";
// import GcpGcsView from "../layouts/gcp/ViewGcs";

// 🔹 Compliance Images
// import PCIDSSImg from "../assets/img/compliance/pci.jpg";
// import HIPPAImg from "../assets/img/compliance/hipaa.jpg";
// import GDPRImg from "../assets/img/compliance/gdpr.jpg";
// import ISOImg from "../assets/img/compliance/iso.jpg";
// import NISTCSF2Img from "../assets/img/compliance/nist-csf-2.0.jpg";

// 🔹 Compliance Sub-Pages
// import PCIDSS from "../layouts/compliance/pcidss";
// import HIPPA from "../layouts/compliance/hippa";
// import ISO27001 from "../layouts/compliance/iso27001";
// import GDPR from "../layouts/compliance/gdpr";
// import NIST from "../layouts/compliance/nist";

// 🧭 Unified Sidebar Map (Icons + Images + Tabs)
const sidebarMap = {
  0: {
    id: 0,
    title: "Dashboard",
    icon: "bi bi-grid-1x2",
    activeIcon: "bi bi-grid-1x2-fill",
    path: "/dashboard",
    component: Dashboard,
  },
  1: {
    id: 1,
    title: "Web Dashboard",
    icon: "bi bi-globe",
    activeIcon: "bi bi-globe2",
    path: "/dashboard/web-dashboard",
    component: WebDashboard,
  },
  2: {
    id: 2,
    title: "Network Dashboard",
    icon: "bi bi-wifi-off",
    activeIcon: "bi bi-wifi",
    path: "/dashboard/network-dashboard",
    component: NetworkDashboard,
  },
  3: {
    id: 3,
    title: "Cloud Dashboard",
    icon: "bi bi-clouds",
    activeIcon: "bi bi-clouds-fill",
    path: "/dashboard/cloud-dashboard",
    component: CloudDashboard,
    subMenu: {
      0: {
        id: 0,
        title: "AWS",
        icon: "bi bi-cloud",
        activeIcon: "bi bi-cloud-fill",
        path: "/dashboard/cloud-dashboard/aws",
        component: AwsDashboard,
        src: AWSIcon,
        alt: "AWS Logo",
        tabs: {
          0: {
            id: 0,
            title: "Misconfigurations",
            path: "/dashboard/cloud-dashboard/aws/misconfigurations",
            component: AwsConfigView,
          },
          1: {
            id: 1,
            title: "EC2 IP Vulnerabilities",
            path: "/dashboard/cloud-dashboard/aws/ec2-ip-vulnerabilities",
            component: AwsEc2View,
          },
          2: {
            id: 2,
            title: "S3 URL Vulnerabilities",
            path: "/dashboard/cloud-dashboard/aws/s3-url-vulnerabilities",
            component: AwsS3View,
          },
        },
      },
      1: {
        id: 1,
        title: "Azure",
        icon: "bi bi-cloud",
        activeIcon: "bi bi-cloud-fill",
        path: "/dashboard/cloud-dashboard/azure",
        component: AzureDashboard,
        src: AzureIcon,
        alt: "Azure Logo",
        tabs: {
          0: {
            id: 0,
            title: "Misconfigurations",
            path: "/dashboard/cloud-dashboard/azure/misconfigurations",
            component: AzureConfigView,
          },
          1: {
            id: 1,
            title: "VM IP Vulnerabilities",
            path: "/dashboard/cloud-dashboard/azure/vms-ip-vulnerabilities",
            component: AzureVmsView,
          },
          2: {
            id: 2,
            title: "Blob URL Vulnerabilities",
            path: "/dashboard/cloud-dashboard/azure/blob-url-vulnerabilities",
            component: AzureBlobView,
          },
        },
      },
      2: {
        id: 2,
        title: "GCP",
        icon: "bi bi-cloud",
        activeIcon: "bi bi-cloud-fill",
        path: "/dashboard/cloud-dashboard/gcp",
        component: GcpDashboard,
        src: GCloudIcon,
        alt: "Google Cloud Logo",
        tabs: {
          0: {
            id: 0,
            title: "Misconfigurations",
            path: "/dashboard/cloud-dashboard/gcp/misconfigurations",
            component: GcpMisconfigurations,
          },
          1: {
            id: 1,
            title: "Compute IP Vulnerabilities",
            path: "/dashboard/cloud-dashboard/gcp/compute-ip-vulnerabilities",
            component: GcpNetworkVulnerabilities,
          },
          2: {
            id: 2,
            title: "Endpoint Vulnerabilities",
            path: "/dashboard/cloud-dashboard/gcp/endpoint-vulnerabilities",
            component: GcpWebVulnerabilities,
          },
        },
      },
      3: {
        id: 3,
        title: "OCI",
        icon: "bi bi-cloud",
        activeIcon: "bi bi-cloud-fill",
        path: "/dashboard/cloud-dashboard/oci",
        component: OciDashboard,
        alt: "Oracle Cloud Infrastructure",
        tabs: {
          0: {
            id: 0,
            title: "Misconfigurations",
            path: "/dashboard/cloud-dashboard/oci/misconfigurations",
            component: OciMisconfigurations,
          },
          1: {
            id: 1,
            title: "Compute IP Vulnerabilities",
            path: "/dashboard/cloud-dashboard/oci/compute-ip-vulnerabilities",
            component: OciNetworkVulnerabilities,
          },
          2: {
            id: 2,
            title: "Endpoint Vulnerabilities",
            path: "/dashboard/cloud-dashboard/oci/endpoint-vulnerabilities",
            component: OciWebVulnerabilities,
          },
        },
      },
    },
  },
  4: {
    id: 4,
    title: "WordPress Sites",
    icon: "bi bi-wordpress",
    activeIcon: "bi bi-wordpress",
    path: "/dashboard/wordpress-sites",
    component: WordPressSites,
  },
  // 4: {
  //   id: 4,
  //   title: "Save Connect",
  //   icon: "bi bi-patch-check",
  //   activeIcon: "bi bi-patch-check-fill",
  //   path: "/dashboard/save-connect",
  //   component: SaveConnect,
  // },
  // 5: {
  //   id: 5,
  //   title: "Analytics",
  //   icon: "bi bi-pie-chart",
  //   activeIcon: "bi bi-pie-chart-fill",
  //   path: "/dashboard/analytics",
  //   component: Analytics,
  // },
  6: {
    id: 6,
    title: "Margdarshak",
    icon: "bi bi-bug",
    activeIcon: "bi bi-bug-fill",
    path: "/dashboard/malware-scanner",
    component: MalwareScanner,
  },
  7: {
    id: 7,
    title: "Dark Web Exposure",
    icon: "bi bi-diagram-3",
    activeIcon: "bi bi-diagram-3-fill",
    path: "/dashboard/darkweb-scanner",
    component: DarkwebScanner,
  },
  // 8: {
  //   id: 8,
  //   title: "Compliance",
  //   icon: "bi bi-file-earmark-medical",
  //   activeIcon: "bi bi-file-earmark-medical-fill",
  //   path: "/dashboard/compliance",
  //   component: Compliance,
  //   subMenu: {
  //     0: {
  //       id: 0,
  //       title: "PCI-DSS",
  //       icon: "bi bi-shield",
  //       activeIcon: "bi bi-shield-fill-check",
  //       path: "/dashboard/compliance/pcidss",
  //       component: PCIDSS,
  //       src: PCIDSSImg,
  //       alt: "PCI-DSS Logo",
  //     },
  //     1: {
  //       id: 1,
  //       title: "HIPPA",
  //       icon: "bi bi-shield",
  //       activeIcon: "bi bi-shield-fill-check",
  //       path: "/dashboard/compliance/hippa",
  //       component: HIPPA,
  //       src: HIPPAImg,
  //       alt: "HIPPA Logo",
  //     },
  //     2: {
  //       id: 2,
  //       title: "ISO 27001",
  //       icon: "bi bi-shield",
  //       activeIcon: "bi bi-shield-fill-check",
  //       path: "/dashboard/compliance/iso27001",
  //       component: ISO27001,
  //       src: ISOImg,
  //       alt: "ISO 27001 Logo",
  //     },
  //     3: {
  //       id: 3,
  //       title: "GDPR",
  //       icon: "bi bi-shield",
  //       activeIcon: "bi bi-shield-fill-check",
  //       path: "/dashboard/compliance/gdpr",
  //       component: GDPR,
  //       src: GDPRImg,
  //       alt: "GDPR Logo",
  //     },
  //     4: {
  //       id: 4,
  //       title: "NIST-CSF-2.0",
  //       icon: "bi bi-shield",
  //       activeIcon: "bi bi-shield-fill-check",
  //       path: "/dashboard/compliance/nist-csf-2.0",
  //       component: NIST,
  //       src: NISTCSF2Img,
  //       alt: "NIST-CSF-2.0 Logo",
  //     },
  //   },
  // },
  9: {
    id: 9,
    title: "Reports",
    icon: "bi bi-clipboard2-data",
    activeIcon: "bi bi-clipboard2-data-fill",
    path: "/dashboard/reports",
    component: Reports,
  },
};

export default sidebarMap;
